var sliders = {
	selectors: { },
	sliderInstances: [],

	init: function () {
		var self = this;

		self.tilesSlider();
		self.contentSlider();
		self.addedTilesSlider();
		self.relatedProductsSlider();
		self.responseGallery();
	},

	resetSliders: function() {
		var self = this;
		console.log( self.sliderInstances );

        // Iterate over all stored slider instances and destroy them
        self.sliderInstances.forEach(function(slider) {
            slider.destroy();
        });
        self.sliderInstances = []; // Reset the slider instances array
    },


	initializeResponseGallery: function() {
		var self = this;
        var slidersToInit = jQuery('.article-gallery__inner:not(.tns-slider), .woocommerce-product-gallery__wrapper:not(.tns-slider)');
        slidersToInit.each(function() {
            let slider = tns({
                container: this,
                items: 1,
                slideBy: 'page',
                gutter: 20,
            });
            self.sliderInstances.push(slider); // Store each initialized slider instance
        });
    },

    responseGallery: function() {
        var self = this;
		
        if (window.innerWidth <= 1023 && self.sliderInstances.length === 0) {
            self.initializeResponseGallery();
        }

        window.addEventListener('resize', function() {
            const screenWidth = window.innerWidth;

            if (screenWidth <= 1023 && self.sliderInstances.length === 0) {
                self.initializeResponseGallery();
            } else if (screenWidth > 1023 && self.sliderInstances.length > 0) {
               	self.resetSliders();
            }
        });
    },


	tilesSlider: function() {
		if( ! jQuery( '.js-tilesSlider' ).length ) {
			return false;
		}

		jQuery( '.js-tilesSlider:not(.tns-slider)' ).each(function() {
			var dataCount = jQuery( this ).attr( 'data-count' );
			dataCount = typeof dataCount !== 'undefined' && dataCount !== false ? dataCount : 5;

			let responsive = {
				768: { 'items': 2 },
				1024: {'items': 3 },
				1280: {'items': parseInt( dataCount ) - 1 },
				1500: {'items': parseInt( dataCount ) },
				1920: {'items': parseInt( dataCount ) }
			};

			if (document.querySelector('.article-layout--post aside') ) {
				responsive = {
					768: { 'items': 2 },
					1024: {'items': 2 },
					1280: {'items': 3 },
					1500: {'items': 3 },
					1920: {'items': 4 }
				};
			}
			
			if ( document.querySelector('.article-layout--post:not(.article-layout--fullwidth):not(:has(aside))' ) ) {
				responsive = {
					768: { 'items': 2 },
					1024: {'items': 2 },
					1280: {'items': 2 },
					1500: {'items': 3 },
					1920: {'items': 4 }
				};
			}

			var slider = tns({
				container: this,
				items: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: true,
				nav: false,
				gutter: 30,
				slideBy: 'page',
				responsive: responsive
			});
		});
	},

	contentSlider: function() {
		if( ! jQuery( '.js-contentTilesSlider' ).length ) {
			return false;
		}
		
		jQuery( '.js-contentTilesSlider:not(.tns-slider)' ).each(function() {
			var dataCount = jQuery( this ).attr( 'data-count' );
			dataCount = typeof dataCount !== 'undefined' && dataCount !== false ? dataCount : 4;

			let responsive = {
				768: { 'items': 2 },
				1024: {'items': 3 },
				1280: {'items': parseInt( dataCount ) - 1 },
				1500: {'items': parseInt( dataCount ) },
				1920: {'items': parseInt( dataCount ) }
			};

			if (document.querySelector('.article-layout--post aside') ) {
				responsive = {
					768: { 'items': 2 },
					1024: {'items': 2 },
					1280: {'items': 3 },
					1500: {'items': 3 },
					1920: {'items': 4 }
				};
			}

			var slider = tns({
				container: this,
				items: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: true,
				nav: false,
				gutter: 30,
				slideBy: 'page',
				responsive: responsive
			});
		});
	},

	addedTilesSlider: function() {
		if( ! jQuery( '.js-addedTilesSlider ul.products' ).length ) {
			return false;
		}
		
		jQuery( '.js-addedTilesSlider ul:not(.tns-slider)' ).each(function() {
			var slider = tns({
				container: this,
				items: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: true,
				nav: false,
				slideBy: 'page',
				responsive: {
					576: {
						'items': 2,
					},
					992: {
						'items': 3,
					}
				}
			});
		});
	},
	
	relatedProductsSlider: function() {
		if( ! jQuery( 'body.single-product .related.products ul.products' ).length ) {
			return false;
		}
		
		jQuery( 'body.single-product .related.products ul.products' ).each(function() {
			var slider = tns({
				container: this,
				items: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: true,
				nav: false,
				slideBy: 'page',
				responsive: {
					576: {
						'items': 2,
					},
					992: {
						'items': 3,
					},
					1240: {
						'items': 4,
					},
					1540: {
						'items': 5,
					}
				}
			});
		});
	},
};

export { sliders };